export const adminEventMetaTags = (params: { eventId: number }) => `event:${params.eventId}`;

export const adminMetaTagsContentTypes = 'metaTagsContentTypes';
